const src = import.meta.ROLLUP_FILE_URL_WFHrEU78LbAH0OIV$gG5mg;
export default {
  src,
  srcSet: src + " " + 2247 + "w",
  width: 2247,
  height: 1053,
};